export type PreciseFPInboundContactSyncSettings = {
  autoSync: boolean
}

export type PreciseFPInboundSyncSettings = {
  contact: PreciseFPInboundContactSyncSettings
}

export type PreciseFPSettingsFormValues = {
  inbound: PreciseFPInboundSyncSettings
}

export const preciseFPSettingsDefaultValues: PreciseFPSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
    },
  },
}
